// extracted by mini-css-extract-plugin
export var defaultFont = "toursBlockContent-module--defaultFont--96012";
export var link = "toursBlockContent-module--link--e8df2";